var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportAnalyserActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_622_2436)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.937983 15.0027H4.72793C5.18575 15.0027 5.57581 14.6721 5.65269 14.2217C6.49326 9.24138 10.7658 5.62633 15.8102 5.62633C17.9537 5.62633 20.0167 6.28925 21.7757 7.54281C22.1494 7.80748 22.6584 7.76716 22.9826 7.44211L25.6618 4.76195C26.0572 4.36665 26.0235 3.70898 25.5739 3.35824C22.7473 1.16154 19.3713 0.000488281 15.8102 0.000488281C7.79452 0.000488281 1.00024 5.99714 0.00765556 13.9488C-0.0630426 14.5069 0.372835 15.0027 0.937983 15.0027ZM16.9977 31.0626V27.2727C16.9977 26.8148 17.3282 26.4248 17.7787 26.3478C22.759 25.5073 26.3741 21.2348 26.3741 16.1904C26.3741 14.0468 25.7112 11.9838 24.4576 10.2248C24.1921 9.85211 24.2342 9.34116 24.5583 9.01792L27.2385 6.33871C27.6287 5.94846 28.2884 5.97321 28.6422 6.4266C30.8389 9.25327 31.9999 12.6293 31.9999 16.1903C31.9999 24.206 26.0032 31.0003 18.0516 31.9929C17.4749 32.0616 16.9977 31.6138 16.9977 31.0626ZM13.8184 31.992C6.58922 31.0883 0.910242 25.4093 0.00741853 18.182C-0.0633421 17.6236 0.372911 17.1281 0.937746 17.1281H4.72769C5.18551 17.1281 5.57557 17.4586 5.65252 17.9091C6.38138 22.2256 9.77207 25.6172 14.0913 26.3469C14.5418 26.4238 14.8723 26.8139 14.8723 27.2718V31.0617C14.8723 31.6194 14.3888 32.0599 13.8184 31.992Z",
    fill: "url(#paint0_linear_622_2436)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8729 19.7535V10.3771C17.8729 9.85927 17.4531 9.43945 16.9352 9.43945H15.06C14.5421 9.43945 14.1223 9.85927 14.1223 10.3771V19.7535C14.1223 20.2713 14.5421 20.6911 15.06 20.6911H16.9352C17.4531 20.6911 17.8729 20.2713 17.8729 19.7535ZM12.2469 12.2521C12.2469 11.7343 11.8271 11.3145 11.3093 11.3145H9.43398C8.91615 11.3145 8.49634 11.7343 8.49634 12.2521V19.7532C8.49634 20.2711 8.91615 20.6909 9.43398 20.6909H11.3093C11.8271 20.6909 12.2469 20.2711 12.2469 19.7532V12.2521ZM23.4986 16.0031V19.7536C23.4986 20.2715 23.0789 20.6913 22.561 20.6913H20.6857C20.1679 20.6913 19.748 20.2715 19.748 19.7536V16.0031C19.748 15.4852 20.1679 15.0654 20.6857 15.0654H22.561C23.0788 15.0654 23.4986 15.4852 23.4986 16.0031Z",
    fill: "url(#paint1_linear_622_2436)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_622_2436",
    x1: 23.4999,
    y1: 31,
    x2: 19.7514,
    y2: 4.06055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_622_2436",
    x1: 19.5136,
    y1: 20.3397,
    x2: 18.5168,
    y2: 10.7877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_622_2436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAnalyserActive);
export default __webpack_public_path__ + "static/media/report_analyser_active.1741d622607c70c16c9e6f54f3922b14.svg";
export { ForwardRef as ReactComponent };